<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Save"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <!-- accoint details tab            -->
      <tab-content
        title="Adding New Profile"
        icon="feather icon-file-text"
        :before-change="validationForm"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Profile Details</h5>
              <small class="text-muted">
                Enter Cybersource profile Details.
              </small>
            </b-col>
            <b-col md="6">
              <b-form-group label="Enter Profile Id" label-for="profileId">
                <validation-provider
                  #default="{ errors }"
                  name="profileId"
                  rules="required"
                >
                  <b-form-input
                    id="profileId-input"
                    v-model.number="requestData.profileId"
                    :state="errors.length > 0 ? false : null"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Enter Access Key" label-for="accessKey">
                <validation-provider
                  #default="{ errors }"
                  name="accessKey"
                  rules="required"
                >
                  <b-form-input
                    id="accessKey-input"
                    v-model.number="requestData.accessKey"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Enter Secret Key" label-for="secretKey">
                <validation-provider
                  #default="{ errors }"
                  name="secretKey"
                  rules="required"
                >
                  <b-form-input
                    id="secretKey-input"
                    v-model.number="requestData.secretKey"
                    :state="errors.length > 0 ? false : null"
                    type="text"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Merchant" label-for="name">
                <b-form-select
                  id="name"
                  v-model="requestData.merchantId"
                  :options="checkedmerchantIds"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
// import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@axios";
// import flatPickr from 'vue-flatpickr-component'

import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BOverlay,
  //   BFormInvalidFeedback,
  BFormSelect,
} from "bootstrap-vue";
import { required } from "@validations";

export default {
  name: "AddLandlord",
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormSelect,
  },
  data() {
    return {
      isLoading: false,
      requestData: {
        merchantId: 0,
        profileId: null,
        accessKey: null,
        secretKey: null,
      },
      accessTypes: [
        { id: 1, name: "GateWay" },
        { id: 2, name: "Merchant" },
      ],
      commissionTypes: [
        { id: 1, name: "Fixed" },
        { id: 2, name: "Percentage" },
      ],
      required,
      merchants: JSON.parse(localStorage.getItem("companies")).filter(
        (c) => c.merchants
      ),
      checkedmerchantIds: [],
    };
  },
  created() {
    this.merchants.forEach((res) => {
      res.merchants.forEach((val) => {
        this.checkedmerchantIds.push({
          value: val.id,
          text: val.name,
        });
      });
    });
    this.requestData.commissionType = this.commissionTypes.find(
      (en) => en.id === 1
    );
  },
  methods: {
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Data Submitted",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    // Call API For persistency
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            this.isLoading = true;
            axios
              .post(
                "/CybersourceProfile/api/V1.0/CybersourceProfile/Create",
                this.requestData
              )
              .then(() => {
                resolve(true);
                this.$router.push("/cybersource/profiles");
              })
              .catch((err) => {
                reject(err);
                this.isLoading = false;
                this.$bvModal.msgBoxOk(err.data.message, {
                  title: "Error",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              });
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
</style>
